import { styled } from "goober";
import type { ComponentProps } from "react";
import { ButtonContent } from "./ButtonContent";
import { baseStyle, buttonClass, type ButtonStyle } from "./buttonStyle";
import { Link } from "../Link";

const Element = styled(Link)`
  ${baseStyle}
  /* An anchor lacks a <button>'s box-sizing and the global.css pill radius. */
  box-sizing: border-box;
  text-decoration: none;
  border-radius: 9999px;
`;

type Props = ButtonStyle & ComponentProps<typeof Link>;

export function ButtonLink({
  variant,
  size,
  icon,
  className,
  children,
  ...props
}: Props) {
  return (
    <Element
      {...props}
      className={buttonClass({ variant, size, icon, children, className })}
    >
      <ButtonContent size={size} icon={icon}>
        {children}
      </ButtonContent>
    </Element>
  );
}
